import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import * as _ from 'lodash';
import request from '@/utils/request';

export class CrudOperates {

  public url: string;
  public key: string;

  constructor(route_url: string, key: string = 'id') {
    this.url = route_url;
    this.key = key;
  }

  public async get() {
    return request({
      url: this.url,
      method: 'get'
    });
  }

  public async get_by_id(entity_id: any) {
    return request({
      url: `${this.url}/${entity_id}`,
      method: 'get'
    });
  }

  public async post(entity_id: any, data: any, timeout: number) {
    return request({
      url: `${this.url}/${entity_id}`,
      method: 'post',
      data: data,
      timeout: timeout
    });
  }

  public async save(entity: any) {
    if (_.isNil(entity[this.key])) {
      return request({
        url: this.url,
        method: 'post',
        data: entity
      });
    } else {
      return request({
        url: `${this.url}/${entity[this.key]}`,
        method: 'put',
        data: entity
      });
    }
  }

  public async saveWithNewId(entity: any, oldId: string) {
    if (_.isNil(entity[this.key]) || entity[this.key] === oldId) {
      return this.save(entity);
    } else {
      return request({
        url: `${this.url}/${oldId}`,
        method: 'put',
        data: entity
      });
    }
  }

  public async delete(entity_id: string | number | null | undefined) {
    if (_.isNil(entity_id)) return;

    return request({
      url: `${this.url}/${entity_id}`,
      method: 'delete'
    });
  }
}

export default {

  getBaseDataSource(api_route: string, key = 'id', filter: any | null = null, filter_field_converter: Function | null = null) {

    const options: any = {
      key: key,
      async byKey(key: any) {
        const resp = await request({
          url: `${api_route}/${key}`,
          method: 'get'
        });
        if (resp.status && resp.data) {
          return resp.data
        }
        return resp;
      },
      async insert(values: any) {
        const resp = await request({
          url: `${api_route}`,
          data: values,
          method: 'post'
        });


        if (resp && resp.data) {
          //
        } else {
          //
        }

        return resp;
      },
      async load(loadOptions: any) {
        let params = '?';

        loadOptions = convertSelectOptions(loadOptions);
        loadOptions = normalizeLoadOptionsSort(loadOptions);

        [
          'skip',
          'take',
          'sort',
          'filter',
        ].forEach((i) => {
          if (i in loadOptions && !_.isNil(loadOptions[i]) && loadOptions[i] !== '') {
            if (i === 'filter' && filter_field_converter) {
              loadOptions[i] = convertFilterFields(loadOptions[i], filter_field_converter);
            }
            const escaped = encodeURIComponent(JSON.stringify(loadOptions[i]));
            params += `${i}=${escaped}&`;
          }
        });
        params = params.slice(0, -1);

        let resp: any = null;
        try {
          resp = await request({
            url: `${api_route}${params}`,
            method: 'get'
          });
        } catch(err) {
          if (err === 'canceled') {
            console.error('!!! DataSource "canceled" exception caught on "request" call !!!')
          } else {
            throw err;
          }
        }


        if (resp && resp.data) {

          //
        } else {
          if (resp.length) {
            let _resp: any = {};
            _resp.data = resp;
            _resp.totalCount = resp.length;

            return _resp;
          }
        }

        return resp;
      },
      async update(key: any, values: any) {
        const resp = await request({
          url: `${api_route}/${key}`,
          data: values,
          method: 'put'
        })
        if (resp && resp.data) {
          //
        } else {
          //
        }
        return resp;
      },
      async remove(key: any) {
        const resp = await request({
          url: `${api_route}/${key}`,
          method: 'delete'
        });
        return resp;
      }
    };

    if (filter) {
      return new DataSource({
        store: new CustomStore(options),
        filter: filter
      })
    } else {
      return new DataSource({
        store: new CustomStore(options)
      })
    }

  },

  getBaseCrud(api_route: string, key: string = 'id') {
    return new CrudOperates(api_route, key);
  }
}

function convertFilterFields(filterExpression: any, filter_field_converter: Function): any {
  if (!(filterExpression instanceof Array) || filterExpression.length === 0) {
    return filterExpression;
  }
  if (!(filterExpression[0] instanceof Array) && filterExpression.length === 3) {
    return convertOneFilterExpression(filterExpression, filter_field_converter)
  } else {
    for (let i = 0; i < filterExpression.length; i++) {
      filterExpression[i] = convertFilterFields(filterExpression[i], filter_field_converter);
    }
  }
  return filterExpression;
}

function convertOneFilterExpression(filterExpression: any, filter_field_converter: Function): any {
  try {
    const result = filter_field_converter(filterExpression);
    filterExpression[2] = result;
  } catch (e) {
  }
  return filterExpression;
}


function convertSelectOptions(selectOptions: any): any {
  // Модификация строки запроса поиска по вводимому значению для DxSelectBox
  if (selectOptions.hasOwnProperty('searchExpr') && selectOptions.searchExpr && selectOptions.searchValue) {
    let oldFilter =  selectOptions.filter || null;
    let newFilter: any[] | null = null;

    if (Array.isArray(selectOptions.searchExpr)) {
      // Поиск по нескольким параметрам
      for (let searchExpr of selectOptions.searchExpr) {
        if (newFilter) {
          newFilter = [ ...(newFilter as any[]), 'or', [ searchExpr, selectOptions.searchOperation, selectOptions.searchValue ] ]
        } else {
          newFilter = [ searchExpr, selectOptions.searchOperation, selectOptions.searchValue ];
          // Если задан поиск по нескольким полям, фильтр формируется как массив условий через 'or'
          if (selectOptions.searchExpr.length !== 1) {
            newFilter = [newFilter];
          }
        }
      }
    } else if (typeof selectOptions.searchExpr === 'string') {
      // Поиск по одному параметру
      newFilter = [ selectOptions.searchExpr, selectOptions.searchOperation, selectOptions.searchValue ];
    }
    else {
      console.log(`dx-select-box: wrong search-expr type: "${typeof selectOptions.searchExpr}". Must be "string" or "string[]"`);
    }
    if (newFilter) {
      let filter: any[] = [];
      if (oldFilter && Array.isArray(oldFilter) && (oldFilter.length > 1) && oldFilter[1] === 'and') {
        filter = [...oldFilter, 'and', newFilter]
      } else {
        filter = oldFilter ? [oldFilter, 'and', newFilter] : newFilter;
      }
      return { ...selectOptions, filter };
    }
  }
  return selectOptions;
}

function normalizeLoadOptionsSort(loadOptions: any): any {
  if (!loadOptions || _.isNil(loadOptions.sort)) {
    return loadOptions;
  }

  const normalizeDescriptor = (descriptor: any): any => {
    if (!descriptor || typeof descriptor !== 'object') {
      return descriptor;
    }

    const normalized = { ...descriptor };

    if (typeof normalized.selector === 'function') {
      const fnName = normalized.selector.name;
      if (fnName) {
        normalized.selector = fnName;
      } else {
        delete normalized.selector;
      }
    }

    if (_.isNil(normalized.selector) || normalized.selector === '') {
      const fallbackSelector =
        normalized.dataField ||
        normalized.field ||
        (typeof normalized.getter === 'string' ? normalized.getter : null) ||
        (typeof normalized.calculateSortValue === 'string' ? normalized.calculateSortValue : null);

      if (fallbackSelector) {
        normalized.selector = fallbackSelector;
      }
    }

    return normalized;
  };

  if (Array.isArray(loadOptions.sort)) {
    return {
      ...loadOptions,
      sort: loadOptions.sort.map(normalizeDescriptor)
    };
  }

  return {
    ...loadOptions,
    sort: normalizeDescriptor(loadOptions.sort)
  };
}
